/**
 * Translated strings (en / fr / es) for the future-dates modal and its trigger
 * (`FutureDatesModal.tsx`, `FutureDatesDesktop.tsx`, `FutureDatesMobile.tsx`,
 * `FutureDatesTrigger.tsx`), also read by
 * `Checkout/ExpressCheckout/QuoteCheckoutFutureDatesModal/QuoteCheckoutFutureDatesModal.tsx` for
 * its title. `customerPartDeliveryDateMessage` is English in all three languages.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** The strings each language of {@link FutureDatesContent} must provide. */
export interface FutureDatesContentProps {
	multipleDates: string;
	availableToShip: string;
	multipleShipments: string;
	quantity: string;
	date: string;
	tbd: string;
	back: string;
	specifyFutureDate: string;
	selectADate: string;
	apply: string;
	remove: string;
	pleaseSelectAlert: string;
	/**
	 * Shown by `FutureDatesModal.tsx` when the delivery-times response is non-empty but has no
	 * entry for the selected rows, or when there are no rows. Lines whose dates don't overlap do
	 * not trigger it.
	 */
	noOverlappingDates: string;
	/** Shown for a customer-part line whose delivery date is TBD: the sales rep confirms it. */
	customerPartDeliveryDateMessage: string;
	deliveryDate: string;
}

/** Strings for the future-dates modal, keyed by language. */
export const FutureDatesContent: LanguageContent<FutureDatesContentProps> = {
	en: {
		multipleDates: "Multiple Dates",
		deliveryDate: "Delivery Date",
		availableToShip: "Available To Ship",
		multipleShipments: "Your order contains multiple shipments. See details below.",
		quantity: "Quantity",
		date: "Date",
		tbd: "TBD",
		back: "Back",
		specifyFutureDate: "Specify Future Date",
		selectADate: "Select a date and apply to hold and ship the total quantity at one time.",
		apply: "Apply",
		pleaseSelectAlert: "Please select a date.",
		remove: "Remove Future Date",
		noOverlappingDates: "These items’ delivery dates don’t have any overlap.",
		customerPartDeliveryDateMessage:
			"Your requested delivery date cannot be confirmed at this time. You will be notified as soon as your sales rep verifies the final delivery date.",
	},
	fr: {
		multipleDates: "Plusieurs dates",
		deliveryDate: "La date de livraison",
		availableToShip: "Prêt à expédier",
		multipleShipments:
			"Votre commande sera expédiée en plusieurs lots. Voir les détails ci-dessous.",
		quantity: "quantité",
		date: "Date",
		tbd: "à détermine",
		back: "Retour",
		specifyFutureDate: "Spécifier une date à venir",
		selectADate:
			"Choisissez une date et appliquez pour réserver et expédier la quantité totale en une fois.",
		apply: "Appliquer",
		pleaseSelectAlert: "Veuillez choisir une date.",
		remove: "Supprimer la date future",
		noOverlappingDates: "Les dates de livraison de ces articles ne coincident pas.",
		customerPartDeliveryDateMessage:
			"Your requested delivery date cannot be confirmed at this time. You will be notified as soon as your sales rep verifies the final delivery date.",
	},
	es: {
		multipleDates: "Varias fechas",
		deliveryDate: "Fecha de entrega",
		availableToShip: "Disponible para expeditar",
		multipleShipments:
			"Su orden contiene múltiples envíos. Consulte los detalles a continuación.",
		quantity: "Quantidad",
		date: "fecha",
		tbd: "por determinar",
		back: "De vuelta",
		specifyFutureDate: "Especificar una futura fecha",
		selectADate:
			"Elija una fecha y aplique para reservar y expeditar la quantidad total en una sola vez.",
		apply: "Aplicar",
		pleaseSelectAlert: "Por favor elija fecha",
		remove: "Cancelar futura fecha",
		noOverlappingDates: "Las fechas de entrego de estos articulos no coinciden.",
		customerPartDeliveryDateMessage:
			"Your requested delivery date cannot be confirmed at this time. You will be notified as soon as your sales rep verifies the final delivery date.",
	},
};
